/**
 * Is this 'thing' a number?
 *
 * @see https://stackoverflow.com/questions/600763/check-if-a-variable-contains-a-numerical-value-in-javascript/601877#601877
 * @param {any} temp The item to test.
 * @return {boolean}
 */
function isNumber( temp ) {

	return isFinite( String( temp ).trim() || NaN )

}


/**
 * Is this 'thing' a string?
 *
 * @param {any} temp The item to test.
 * @return {boolean}
 */
function isString( temp ) {

	return 'string' === typeof temp;

}


/**
 * Is this 'thing' an array?
 *
 * @param {any} temp The item to test.
 * @return {boolean}
 */
function isArray( temp ) {

	if ( !temp ) {
		return false;
	}

	if ( temp.constructor ) {
		return temp.constructor === Array;
	}

	return false;

}
